<div class="container mb-2">
  <div class="row">
    <div class="col-12">
      <h1 class="page-title">{{ "QFR" | globalTranslate }}</h1>
    </div>
  </div>
  <div class="row">
    <div class="card pb-2 px-0" style="width: 100%">
      <div class="card-body">
        <div>
          <a
            tabindex="0"
            class="btn ps-0 btn-link"
            [routerLink]="['/user-profile', 'benefit-dashboard']"
          >
            <i class="fa fa-arrow-left"></i>
            <span class="ps-2">{{
              "BACK_TO_DASHBOARD" | globalTranslate
            }}</span>
          </a>
        </div>
        @if (response) {
        <div class="d-none d-lg-block">
          <div class="row">
            <nh-alert type="warning" [isOpen]="pretermDuplicateSubmission">
              <div class="row">
                <div class="col-auto icon">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt="warning"
                  />
                </div>
                <div class="col message">
                  <span
                    >{{ "QFR_WARNING_MESSAGE_1" | globalTranslate }}
                    {{ submittedNames
                    }}{{ "QFR_WARNING_MESSAGE_2" | globalTranslate }}</span
                  >
                </div>
              </div>
            </nh-alert>
            <nh-alert type="warning" [isOpen]="pretermRecentFaxSubmission">
              <div class="row">
                <div class="col-auto icon">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt="warning"
                  />
                </div>
                <div class="col message">
                  <span>{{ "QFR_WARNING_2" | globalTranslate }}</span>
                </div>
              </div>
            </nh-alert>
            <table class="table">
              <thead>
                <tr>
                  <th class="col-md-6">{{ "Case" | globalTranslate }}</th>
                  <th>{{ "Due Date" | globalTranslate }}</th>
                  <th>{{ "Action" | globalTranslate }}</th>
                </tr>
              </thead>
              <tbody>
                @for (row of this.rows; track row) {
                <tr>
                  @if (row.leastPretermDueDate) {
                  <td>
                    {{ row.caseNum }} <br /><br />
                    {{ row.hohName }} {{ "QFR_STATIC" | globalTranslate }}
                    <strong>{{ row.nonHoh }}.</strong>
                  </td>
                  } @if (row.leastPretermDueDate) {
                  <td class="align_content">
                    {{ row.leastPretermDueDate | date: "MM/dd/yyyy" }}
                  </td>
                  } @if (row.leastPretermDueDate) {
                  <td>
                    <button
                      class="btn btn-block btn-rbsecondary"
                      (click)="pretermWelcomePage(row)"
                    >
                      {{ "QFR_COMPLETE" | globalTranslate }}
                    </button>
                  </td>
                  }
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        } @if (response) {
        <div>
          <div class="nh-table-mobile d-lg-none">
            @if (rows.length) { @for (row of rows; track row) {
            <div>
              @if (row.leastPretermDueDate) {
              <div class="table-row mb-3 pb-3">
                <div class="mobile-table-header">
                  {{ "Case" | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">
                  {{ row.caseNum }} <br /><br />
                  {{ row.hohName }} {{ "QFR_STATIC" | globalTranslate }}
                  <strong>{{ row.nonHoh }}.</strong>
                </div>
                <br />
                <div class="mobile-table-header">
                  {{ "Due Date" | globalTranslate }}
                </div>
                <hr />
                <div class="mobile-table-data">
                  {{ row.leastPretermDueDate | date: "MM/dd/yyyy" }}
                </div>
                <br />
                <div class="mobile-table-header">
                  {{ "Action" | globalTranslate }}
                </div>
              </div>
              }
              <div class="mobile-table-data">
                <button
                  class="w-100 btn d-grid btn-block btn-rbsecondary"
                  (click)="pretermWelcomePage(row)"
                >
                  {{ "QFR_COMPLETE" | globalTranslate }}
                </button>
              </div>
              <br />
              <hr />
            </div>
            } } @if (!rows.length) {
            <p class="mb-5">{{ "NO_DATA_TO_DISPLAY" | globalTranslate }}</p>
            }
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
